module.exports = __webpack_public_path__ + "fonts/la-brands-400.3a8109c.woff2";